type UnicornStudioScene = {
  resize?: () => void;
  destroy?: () => void;
};

declare global {
  interface Window {
    UnicornStudio?: {
      addScene: (opts: Record<string, unknown>) => Promise<UnicornStudioScene>;
      destroy: () => void;
    };
  }
}

let loader: Promise<NonNullable<Window['UnicornStudio']>> | null = null;

export function loadUnicornStudio(): Promise<NonNullable<Window['UnicornStudio']>> {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('UnicornStudio can only be loaded in the browser'));
  }
  if (window.UnicornStudio) return Promise.resolve(window.UnicornStudio);
  if (loader) return loader;

  loader = import('./vendor/unicornStudio.umd.js').then(() => {
    if (!window.UnicornStudio) {
      throw new Error('UnicornStudio SDK loaded but global was not found');
    }
    return window.UnicornStudio;
  });

  return loader;
}
